import { useCallback } from 'react'
import {
  useRequestBreakGlassPartnerWriteAccessMutation,
  type RequestBreakGlassPartnerWriteAccessMutationVariables,
} from '../../__codegen__/api'

export const useRequestBreakGlassPartnerWriteAccess = () => {
  const [triggerMutation, { data, loading, error, called }] =
    useRequestBreakGlassPartnerWriteAccessMutation()

  const submit = useCallback(
    (variables: RequestBreakGlassPartnerWriteAccessMutationVariables) =>
      triggerMutation({
        variables,
      }),
    [triggerMutation]
  )

  return {
    submit,
    apiSuccess: data?.enterpriseAccountRequestBreakGlassPartnerWriteAccess && !error,
    apiLoading: loading,
    apiCalled: called,
    apiError: error,
  }
}
